import Fetch from 'utils/fetch'
import { generateQueryList } from '../../../../utils/custom-functions';

export const downloadData = (route) => {
  return Fetch.get(`${route}`);
}

export const downloadDataWithFilters = (filters, route) => {
  const startDate = filters.dataDe ? `StartDate=${filters.dataDe}&` : ''
  const endDate = filters.dataAte ? `EndDate=${filters.dataAte}&` : ''
  const labeledFamilyId = `${generateQueryList(filters.labeledFamily, "LabeledFamilyIds")}`
  const businessUnitId = `${generateQueryList(filters.center, "BusinessUnitIds")}`
  const supplierIds = `${generateQueryList(filters.supplier, "SupplierIds")}`
  const materialGroupIds = `${generateQueryList(filters.materialGroup, "MaterialsGroupIds")}`
  const countries = filters.countries ? `${generateQueryList(filters.countries, "Countries")}` : '';
  const activeMaterial =
    filters.activeMaterial === "activeMaterial" ? `ActiveMaterials=${true}` : "";

  const query =
    `${startDate}${endDate}${labeledFamilyId}${businessUnitId}${supplierIds}${materialGroupIds}${countries}${activeMaterial}`.replace(
      /\s/g,
      ""
    );

  return Fetch.get(`${route}?${query}`)
}

export const getLastUpdates = () => {
  return Fetch.get('datauploadinfo/lastupdates').then(x => x.data);
}

export const getLabeledFamilyByBottle = () =>
  Fetch.get(`/labeled-families:all-with-bottles`).then(({ data }) => data)

export const getAllLabeledFamilies = () =>
  Fetch.get(`/labeled-families:for-filters`).then(({ data }) => data)

export const getBusinessUnitByLabeledFamily = (labeledFamilys) => {
  const filter = labeledFamilys.map(family => `LabeledFamilyId=${family.Id}`)
  const query = filter.length > 1 ? filter.join("&") : filter.join('')

  return Fetch.get(`business-units/for-filters?${query}`).then(({ data }) => data)
}

export const getBusinessUnitByCountries = async (countries) => {
  const filter = countries.map((country) => `Countries=${country.Id}`);
  const query = filter.length > 1 ? filter.join("&") : filter.join("");

  const { data } = await Fetch.get(`business-units/for-filters?${query}`);
  return data;
};

export const getSuppliersByLabeledFamilyAndBusinessUnit = (params) => {
  const defaultFilter = `UseDefaultFilter=${params.useDefaultFilter}&`
  const labeledFamilyId = `${generateQueryList(params.labeledFamily.map(family => family.Id), "LabeledFamilyId")}`
  const businessUnitId = `${generateQueryList(params.businessUnit.map(center => center.Id), "BusinessUnitId")}`

  const query = `${defaultFilter}${labeledFamilyId}${businessUnitId}`.replace(/\s/g, "")

  return Fetch.get(`suppliers:for-filters?${query}`).then(({ data }) => data)
}

export const getMaterialGroups = (params) => {
  const defaultFilter = `UseDefaultFilter=${params.useDefaultFilter}`

  return Fetch.get(`material-groups:for-filters?${defaultFilter}`).then(({ data }) => data)
}

export const getCountriesForBusinessUnits = () =>
  Fetch.get(`countries:for-business-units`).then(({ data }) => data)